'use client';

import type {
  ProductDetailData,
  VariantsEntity,
} from '@eliadmin/core/src/api/products/types/product-types';
import { Heading } from '../../ui/heading';
import { Paragraph } from '../../ui/paragraph';

export function ProductTabsParameters({
  product,
  selectedVariant,
}: {
  product: ProductDetailData;
  selectedVariant?: VariantsEntity;
}) {
  // The tab is shown when the product has attributes, but only the selected variant's values were
  // rendered — without a selected variant the tab was empty. Fall back to the product attributes.
  const rows =
    selectedVariant?.values && selectedVariant.values.length > 0
      ? selectedVariant.values.map(value => ({
          key: `${value.attribute_id}-${value.id}`,
          label: value?.attribute_name ?? '',
          value: value.name,
        }))
      : (product?.attributes ?? []).map(attribute => ({
          key: `${attribute.id}`,
          label: attribute.name,
          value: (attribute.values ?? []).map(v => v.name).join(', '),
        }));

  return (
    <div className="flex w-full flex-col items-center justify-center gap-6 sm:gap-8">
      <Heading title="Technické parametre" tag="h2" styleAs="h4" center />
      <div className="flex w-full flex-col items-center justify-center gap-2">
        {rows.map(row => (
          <div
            key={row.key}
            className="grid w-full grid-cols-2 gap-2 rounded-[12px] bg-white p-3 sm:gap-3 sm:p-4 lg:gap-4"
          >
            <Heading
              tag="p"
              styleAs="h6"
              title={row.label}
              className={{ container: 'col-span-1 w-full' }}
            />
            <Paragraph className="col-span-1 w-full" color="black" size="lg">
              {row.value}
            </Paragraph>
          </div>
        ))}
      </div>
    </div>
  );
}
